export default "__VITE_ASSET__B23RNbqD__"